import { useEffect, useState } from 'react';
import { getFailedEffects } from '@/lib/syncQueue';

const POLL_MS = 2000;
const DEAD_LETTER_KEY = 'team-v-does-sync-dead-letter';

/**
 * Returns the current size of the offline-sync dead-letter queue.
 *
 * Updates via the `storage` event for cross-tab failures and a 2s poll
 * for same-tab handler writes. Cheap by design — reads localStorage, no
 * custom event channel needed. Lets the app shell surface a badge without
 * the user having to wander into Settings → Failed sync.
 */
export function useFailedSyncCount(): number {
  const [count, setCount] = useState<number>(() => getFailedEffects().length);

  useEffect(() => {
    const refresh = () => setCount(getFailedEffects().length);
    refresh();

    const handle = window.setInterval(refresh, POLL_MS);
    const onStorage = (e: StorageEvent) => {
      if (e.key === DEAD_LETTER_KEY) refresh();
    };
    window.addEventListener('storage', onStorage);

    return () => {
      window.clearInterval(handle);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return count;
}
